import {
  OWNER_REGISTER_REQUEST,
  OWNER_REGISTER_SUCCESS,
  OWNER_REGISTER_FAIL,
  OWNER_LOGIN_REQUEST,
  OWNER_LOGIN_SUCCESS,
  OWNER_LOGIN_FAIL,
  OWNER_LOGOUT,
  OWNER_DETAILS_REQUEST,
  OWNER_DETAILS_SUCCESS,
  OWNER_DETAILS_FAIL,
  OWNER_UPDATE_PROFILE_REQUEST,
  OWNER_UPDATE_PROFILE_SUCCESS,
  OWNER_UPDATE_PROFILE_FAIL,
  OWNER_UPDATE_PROFILE_RESET,
  OWNER_DISABLE_REQUEST,
  OWNER_DISABLE_SUCCESS,
  OWNER_DISABLE_FAIL,
  OWNER_DELETE_REQUEST,
  OWNER_DELETE_SUCCESS,
  OWNER_DELETE_FAIL
} from '../constants/ownerConstants.js'

export const ownerRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_REGISTER_REQUEST:
      return { loading: true }
    case OWNER_REGISTER_SUCCESS:
      return { loading: false, success: true, ownerInfo: action.payload }
    case OWNER_REGISTER_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const ownerLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_LOGIN_REQUEST:
      return { loading: true }
    case OWNER_LOGIN_SUCCESS:
      return { loading: false, ownerInfo: action.payload }
    case OWNER_LOGIN_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_LOGOUT:
      return {}
    default:
      return state
  }
}

export const ownerDetailsReducer = (state = { owner: {} }, action) => {
  switch (action.type) {
    case OWNER_DETAILS_REQUEST:
      return { ...state, loading: true }
    case OWNER_DETAILS_SUCCESS:
      return { loading: false, owner: action.payload }
    case OWNER_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const ownerUpdateProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_UPDATE_PROFILE_REQUEST:
      return { loading: true }
    case OWNER_UPDATE_PROFILE_SUCCESS:
      return { loading: false, success: true, ownerInfo: action.payload }
    case OWNER_UPDATE_PROFILE_FAIL:
      return { loading: false, error: action.payload }
    case OWNER_UPDATE_PROFILE_RESET:
      return {}
    default:
      return state
  }
}

export const ownerDisableReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_DISABLE_REQUEST:
      return { loading: true }
    case OWNER_DISABLE_SUCCESS:
      return { loading: false, success: true }
    case OWNER_DISABLE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const ownerDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case OWNER_DELETE_REQUEST:
      return { loading: true }
    case OWNER_DELETE_SUCCESS:
      return { loading: false, success: true }
    case OWNER_DELETE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}
